/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

export default interface ServiceTierRequest {
  id: string;
  terminalId: string;
  terminalDisplayName: string;
  requestedServiceTier: string;
  requesterUserId: string;
  requesterFullName: string;
  requesterEmail: string;
  requesterOrgId: number;
  submittedDate: Date;
  status: ServiceTierRequestStatus;
  responderUserId: string;
  completedDate: Date;
}

export enum ServiceTierRequestStatus {
  SUBMITTED = 'SUBMITTED',
  IN_PROGRESS = 'IN_PROGRESS',
  DENIED = 'DENIED',
  COMPLETED = 'COMPLETED',
}
